module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['content', {
      'zh-style': _vm.lang === 'zh'
    }]
  }, [(_vm.records.length === 0 && !_vm.loading) ? _c('empty-reminder') : _vm._e(), _vm._v(" "), (_vm.records.length > 0) ? _c('div', {
    attrs: {
      "id": "pc-record-box"
    }
  }, [_c('div', {
    staticClass: "little-title"
  }, [_c('p', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.$t('time')))]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.$t('description')))])]), _vm._v(" "), _vm._l((_vm.records), function(record) {
    return _c('div', {
      staticClass: "records"
    }, [_c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("createFormatTime")(record.created_at, record.created_at)))]), _vm._v(" "), _c('p', {
      staticClass: "description"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('user')) + _vm._s(record.nickname) + _vm._s(_vm.$t(record.status)))])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "pager-bar"
    }
  }, [_c('div', {
    staticClass: "spinner-component-box"
  }, [_c('spinner', {
    attrs: {
      "show": _vm.loading
    }
  })], 1), _vm._v(" "), _c('pager', {
    attrs: {
      "total-page": _vm.totalPage,
      "init-page": _vm.currentPage
    },
    on: {
      "go-page": _vm.getRecords
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4865dffc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/commission/friendRecords/FriendRecordsPc.vue
// module id = 1316
// module chunks = 1